import { useEffect } from 'react'

export const useChangeLocalhostUrl = (): void => {
  useEffect(() => {
    if (window.location.hostname === 'localhost') {
      window.location.href = `http://127.0.0.1:${window.location.port}`
    }
  }, [])
}
